import React from "react";
import { Text } from "react-native";

const Heading = (props) => {

    const { type = "h1", numberOfLines = 1, ...rest } = props;

    const styles = 
        {
            padding: 0,
            margin: 0,
            fontFamily: "JosefinSans",
            fontWeight: "350",
            lineHeight: "120%",
            color: "#212427",
            ...(numberOfLines && {
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: numberOfLines,
                WebkitBoxOrient: "vertical",
                textOverflow: "ellipsis",
                
            }),
            ...(!Array.isArray(props?.style) ? props?.style : {}),
            
    };

    switch (type) {
        case "h1":
            return <h1 {...rest} style={styles} >{props.text}{props.children}</h1> ;
        case "h2":
            return <h2 {...rest} style={styles} >{props.text}{props.children}</h2> ;
        case "h3":
            return <h3 {...rest} style={styles} >{props.text}{props.children}</h3> ;
        case "h4":
            return <h4 {...rest} style={styles} >{props.text}{props.children}</h4> ;
        case "h5":
            return <h5 {...rest} style={styles} >{props.text}{props.children}</h5> ;
        case "h6":
            return <h6 {...rest} style={styles} >{props.text}{props.children}</h6> ;
        default:
            return <h6 {...rest} style={styles} >{props.text}{props.children}</h6> ;
    }
};

export default Heading;
